import styled from 'styled-components';

export const Header = styled.div`
    width: 65%;
    gap: 4px;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const HeaderTitle = styled.span`
    color: ${(props) => (props.theme.theme === 'light' ? '#262626' : '#fff')};
    font-size: 16px;
    font-weight: 500;
`;

export const HeaderSubtitle = styled.h1`
    font-size: 14px;
    margin: 0;
    color: #8c8c8c;
    font-weight: 400;
`;

export const HeaderPlanogramAutomationArea = styled.div`
    padding: 24px 0px;
`;
